<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
 
  import {SEARCH_EVENTS} from '../../../../graphql/events';
  
  const client = getContext('apollo');

  import Loader from '../../../../components/ui/loader.html';
  import Event from '../../../events/components/event.html';
  import Search from '../../../../components/inputs/search.html';
  import moment from 'moment';

  export let program;
  export let id;

  let search = {program: id, startDate: moment().subtract(2, 'years'), endDate: moment().subtract(1, 'day')};
  let query = client.watchQuery({ query: SEARCH_EVENTS, variables: {search} });
  let results = {loading: true};

  function setResponse({data, loading, error, networkStatus}) {
    results = {
      loading,
      page: data && data.events ? data.events.page : 1,
      total: data && data.events ? data.events.total : 0,
      events: data && data.events ? data.events.docs : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function searchPeople() {
    query.refetch({search, page: 1});
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search,
        page: results.page + 1
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          people: {
            ...fetchMoreResult.events,
            docs: [...prev.events.docs, ...fetchMoreResult.events.docs]
          }
        });
      }
    });
  }
</script>


<div class="grid-x grid-margin-x">
  <!--<div class="cell small-12 medium-12">
    <Search placeholder="Search Program Events" />
  </div>-->
  <div class="cell small-12 medium-12">
    {#if results.loading}
      <Loader></Loader>
    {/if}
    {#if !results.loading}
      <div class="grid-x grid-margin-x small-up-1">
        {#each results.events as event, i}
          <div class="cell">
            <Event event={event} />
          </div>
        {/each}
      </div>
      {#if (results.total === 0)}
        <div class="callout">
          <p>This program has no past events</p>
        </div>
        {/if}
    {/if}
  </div>
</div>
